import React, { useState } from 'react'
import { makeStyles, useTheme } from '@mui/styles'
import { useDispatch } from 'react-redux'
import clsx from 'clsx'

import SVGIcon from '../svg-icon/svg-icon'
import favoriteIcon from 'assets/images/icons/favorite.svg'
import { updateAccountFavorite } from '../../../../redux/ducks/taxCategories/main'

const TaxCategorySubItem = (props) => {
  const dispatch = useDispatch()
  const theme = useTheme()
  const { account, onClick } = props
  const { accountNo, accountDescriptionCustom } = account
  const classes = useStyles(props)
  const [isLoading, setIsLoading] = useState(false)

  const handleItemClick = () => {
    onClick(account)
  }

  const handleFavoriteClick = (event) => {
    event.preventDefault()
    setIsLoading(true)
    dispatch(updateAccountFavorite(account))
      .finally(() => setIsLoading(false))
  }

  return (
    <div className={classes.wrapper}>
      <div className={classes.accountInfo} onClick={handleItemClick}>
        <span className={classes.accountNo}>{accountNo}</span>
        <span className={classes.description}>{accountDescriptionCustom}</span>
      </div>
      <div className={clsx(classes.iconWrapper, account.favorite || isLoading ? 'flex' : 'hidden')}>
        <SVGIcon
          svg={favoriteIcon}
          width='15px'
          height='15px'
          fill={account.favorite ? theme.primary : theme.lightGrey}
          customClass={clsx(classes.icon, isLoading && classes.iconAnimation)}
          onClick={handleFavoriteClick} />
      </div>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  '@keyframes pulseOpacity': {
    '0%': {
      opacity: 1,
    },
    '50%': {
      opacity: 0.3,
    },
    '100%': {
      opacity: 1,
    },
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    height: 50,
    width: '100%',
    borderBottom: `1px solid ${theme.borderColor}`,
    '&:hover $iconWrapper': {
      display: 'flex',
    },
  },
  accountInfo: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    paddingLeft: 20,
    gap: 10,
  },
  accountNo: {
    color: theme.lightGrey,
    width: 35,
    textAlign: 'right',
  },
  description: {
    flex: 1,
  },
  iconWrapper: {
    paddingRight: 30,
  },
  iconAnimation: {
    animation: '$pulseOpacity 1s ease-in-out infinite',
    pointerEvents: 'none',
  },
}))

export default TaxCategorySubItem
